import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import CloseIcon from "../../assets/svg/CloseIcon";
import LogoIcon from "../../assets/svg/Logo";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  return (
    <Wrapper className="animate darkBg" sidebarOpen={sidebarOpen}>
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <LogoIcon />
          <h1 className="whiteColor font20" style={{ marginLeft: "15px" }}>
            fanatic
          </h1>
        </div>
        <CloseBtn
          onClick={() => toggleSidebar(!sidebarOpen)}
          className="animate pointer"
        >
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      <UlStyle className="flexNullCenter flexColumn">
        {[
          { label: "Home", to: "home" },
          { label: "Services", to: "services" },
          { label: "Projects", to: "projects" },
          { label: "Blog", to: "blog" },
          { label: "Pricing", to: "pricing" },
          { label: "Contact", to: "contact" },
        ].map(({ label, to }) => (
          <li className="semiBold font15 pointer" key={to}>
            <Link
              onClick={() => toggleSidebar(!sidebarOpen)}
              activeClass="active"
              className="whiteColor"
              style={{ padding: "10px 15px" }}
              to={to}
              spy={true}
              smooth={true}
              offset={-60}
            >
              {label}
            </Link>
          </li>
        ))}
      </UlStyle>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 100%;
  max-width: 400px;
  height: 100vh;
  position: fixed;
  top: 0;
  padding: 0 20px;
  right: ${(props) => (props.sidebarOpen ? "0px" : "-100%")};
  background-color: #1e1e1e;
  transition: right 0.3s ease;
  z-index: 9999;
  @media (max-width: 400px) {
    padding: 0 15px;
  }
`;

const SidebarHeader = styled.div`
  padding: 20px 0;
`;

const CloseBtn = styled.button`
  border: 0;
  outline: none;
  background-color: transparent;
  padding: 10px;
  color: white;
`;

const UlStyle = styled.ul`
  width: 100%;
  li {
    margin: 20px 0;
    width: 100%;
    text-align: left;
  }
`;
